import { render, staticRenderFns } from "./Costing-barcode.vue?vue&type=template&id=8bf20ef8"
import script from "./Costing-barcode.vue?vue&type=script&lang=js"
export * from "./Costing-barcode.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports